module.exports = __webpack_public_path__ + "img/D_Read_more_graph_female.cbc656aa.svg";